import { Edit } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, IconButton } from '@mui/material';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import {
  getWorkspacePaidButNotOnboarded,
  ISaveWorkspacePaidButNotOnboardedParam,
} from 'wisestep-api';
import { WsTypography, WsColors, WsDialog, formatDateToMonthDayYearString } from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard';

import PaidButNotOnboardedCustomersForm from './PaidButNotOnboardedCustomersForm';

type ArrayInterface = {
  headerName?: string;
  field: string;
  width: number;
};
const PaidButNotOnboardedCustomerDetails = ({ payload }) => {
  const paginationSize = 10;
  const [tableData, setTableData] = useState<object[]>([]);
  const [columnDefinition, setColumnDefinition] = useState<ArrayInterface[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<ISaveWorkspacePaidButNotOnboardedParam>();

  const handleEditClick = (rowData: ISaveWorkspacePaidButNotOnboardedParam) => {
    setSelectedRowData(rowData);
    setOpenModal(true);
  };

  const handleClose = () => setOpenModal(false);

  useEffect(() => {
    async function fetchData() {
      const response = await getWorkspacePaidButNotOnboarded(payload);

      const columnDefs = [
        { headerName: 'Company Name', field: 'companyName', width: 200 },
        { headerName: 'No.of Users Paid', field: 'numberOfUsersPaid', width: 140 },
        { headerName: 'Currency', field: 'currency', width: 120 },
        { headerName: 'Amount', field: 'amount', width: 150 },
        { headerName: 'Paid Date', field: 'paidDate', width: 150 },
        { headerName: 'Onboarded Status', field: 'onboardedStatus', width: 140 },
        { headerName: 'Onboarded Date', field: 'onboardedDate', width: 140 },
        { headerName: 'Workspace Name', field: 'workspaceName', width: 200 },
        {
          headerName: 'Actions',
          field: 'actions',
          width: 80,
          renderCell: (params: GridCellParams) => {
            return (
              <IconButton onClick={() => handleEditClick(params.row)}>
                <Edit sx={{ color: WsColors.TheBlues500 }} />
              </IconButton>
            );
          },
        },
      ];

      const tableDataLocal = response.data.map((row) => {
        let formattedOnboardedDate = '';
        if (row.onboardedDate != null) {
          const onboardedDate = new Date(row.onboardedDate);
          if (!isNaN(onboardedDate.getTime())) {
            formattedOnboardedDate = formatDateToMonthDayYearString(onboardedDate);
          }
        }

        return {
          id: row.id,
          companyName: row.companyName,
          numberOfUsersPaid: row.numberOfUsersPaid,
          currency: row.currency,
          amount: row.amount,
          paidDate: formatDateToMonthDayYearString(new Date(row.paidDate)),
          onboardedStatus: row.onboardedStatus,
          isOnboarded: row.onboardedStatus ? 'yes' : 'no',
          onboardedDate: formattedOnboardedDate ?? null,
          workspaceName: row.workspaceName,
          createdOn: new Date(row.createdOn),
        };
      });

      setColumnDefinition(columnDefs);
      setTableData(tableDataLocal);
    }

    fetchData();
  }, [payload]);

  return (
    <Grid container>
      <WsTypography>Paid But Not Onboarded Customers Details</WsTypography>
      {tableData.length > 0 ? (
        <Box style={{ height: 500, width: '100%', background: WsColors.White }} paddingTop={2}>
          <DataGrid
            sx={{
              '& .MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle': {
                fontWeight: '800',
              },
            }}
            columns={columnDefinition}
            rows={tableData}
            components={{ Toolbar: GridToolbar }}
            pageSize={paginationSize}
            rowsPerPageOptions={[paginationSize]}
          />
        </Box>
      ) : (
        <NoDataFoundCard text="No Records Found" />
      )}
      <WsDialog openDialog={openModal} size="medium" onClose={handleClose}>
        <>
          <Box>
            <CloseIcon
              onClick={() => setOpenModal(false)}
              sx={{ float: 'right', mr: 2, fontSize: '22px', mt: 2, cursor: 'pointer' }}
            />
          </Box>
          <PaidButNotOnboardedCustomersForm usersData={selectedRowData} />
        </>
      </WsDialog>
    </Grid>
  );
};
export default PaidButNotOnboardedCustomerDetails;
